<template>
	<div>
		<span  v-for="(item,index) in 5" :key="index+1" 
		:class="`${index < num ? 'active-star' : 'gray-star'}${readOnly ? ' read-only' : ''}`" 
		@click='handleClick' :data-index="index+1"></span>
	</div>
</template>

<script>
	export default{
		props:{
			max:{
				type:Number,
				default:5
			},
			selected:{
				type:Number,
				default: 0
			},
			readOnly:{
				type:Boolean,
				default: false
			},
			formIndex:
			{
				type:Number,
				default: 0
			}
		},
	
		data(){
			return{
				num: this.selected
			}
		},
		methods:{
			handleClick(event){
				if(this.readOnly) return ;
				const index = event.target.getAttribute('data-index');
				const newRating = parseInt(index);
				this.num = newRating;
				this.$emit('rating-changed',newRating,this.formIndex);
			}
		}
	}
</script>

<style scoped>
	.read-only{
		cursor: default;
	}
	
	.active-star{
	/* 	content: '★'; */
		width: 20px;
		height: 20px;
		background-color: #ffca03;
		display: inline-block;
		clip-path: polygon(
			50% 0%,
			61% 35%,
			98% 35%,
			68% 57%,
			79% 91%,
			50% 70%,
			21% 91%,
			32% 57%,
			2% 35%,
			39% 35%
		);
		
	}
	
	.gray-star{
		/* content: '★'; */
		width: 20px;
		height: 20px;
		background-color: #e2e2e2;
		display: inline-block;
		clip-path: polygon(
			50% 0%,
			61% 35%,
			98% 35%,
			68% 57%,
			79% 91%,
			50% 70%,
			21% 91%,
			32% 57%,
			2% 35%,
			39% 35%
		);
	}
	
	span{
		margin-right: 3px;
		cursor: pointer;
	}
</style>